import { render, staticRenderFns } from "./brush.vue?vue&type=template&id=34ffa43a&"
import script from "./brush.vue?vue&type=script&lang=js&"
export * from "./brush.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ffa43a')) {
      api.createRecord('34ffa43a', component.options)
    } else {
      api.reload('34ffa43a', component.options)
    }
    module.hot.accept("./brush.vue?vue&type=template&id=34ffa43a&", function () {
      api.rerender('34ffa43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/brush.vue"
export default component.exports